<template>
  <div class="signin">
    <div class="signin-background">
      <div class="signin-heit">
        <img src="../../public/obraoag/PersHeadPort.png" alt="">
      </div>
      <div class="signin-acoter signin-aomber">
        <el-input v-model="signacnt" placeholder="请输入手机号码或昵称" clearable @input="signacer()"></el-input>
      </div>
      <div class="signin-acoter signin-ptword">
        <el-input type="password" v-model="signpaor" placeholder="请输入密码" clearable show-password @input="signpard()"></el-input>
      </div>
      <router-link :to="{path: 'register',query: {siyzstate: '14',servmope: '1'}}">
        <div class="signin-foet">忘记密码</div>
      </router-link>
      <div class="signin-cofm" @click="signcfrm()">确认</div>
      <div class="signin-noct">
        还没账号? <router-link :to="{path: 'register',query: {siyzstate: '13'}}">立即注册</router-link>
      </div>
    </div>
    <!-- 失败提示 -->
    <div id="warnToast" :style="'display:' + signfail">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-icon-warn weui-icon_toast"></i>
        <p class="weui-toast__content">{{signtips}}</p>
      </div>
    </div>
    <!-- 成功提示 -->
    <div id="toast" :style="'display:' + sidnsucs">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-icon-success-no-circle weui-icon_toast"></i>
        <p class="weui-toast__content">{{signtips}}</p>
      </div>
    </div>
    <!-- 温馨提示 -->
    <div class="js_dialog" id="iosDialog1" :style="'display:' + signment">
      <div class="weui-mask"></div>
      <div class="weui-dialog">
        <div class="weui-dialog__bd" style="margin: 0 0 .12rem 0;font-size: .3rem;">声明与条款</div>
        <div class="weui-dialog__bd" style="text-align: left;font-size: .26rem;">
          <p class="signin-dice">欢迎你使用欧堡利亚APP。</p>
          <p class="signin-dice">我们将严格遵守相关法律法规和隐私政策以保护您的个人信息。</p>
          <p class="signin-dice">为提供基本服务，需要联网以及调用你的如下权限或功能,以收集必要的个人信息: </p>
          <p class="signin-dice">必要权限（用于该应用的基本服务和功能) </p>
          <p class="signin-dice">·获取手机账号信息:</p>
          <p class="signin-dice">用于应用内使用账号快速登录的功能;</p>
          <p class="signin-dice">可选权限(用于附加功能，将在使用相关功能时申请)</p>
          <p class="signin-dice">如果你不同意调用以上必要权限或功能,或不同意我们收集并使用以上信息,将导致本应用无法正常运行,你可选择卸载本应用/退出本应用/前往“设置”>“权限管理”关闭授权以终止服务。</p>
          <p>请你阅读并同意
          <router-link :to="{path:'userment'}" class="signin-agnt">《用户协议》</router-link>和
          <router-link :to="{path:'privolcy'}" class="signin-agnt">《隐私政策》</router-link>。</p>
        </div>
        <div class="weui-dialog__ft">
          <a href="javascript:" class="weui-dialog__btn weui-dialog__btn_default" @click="signfuse()">拒绝</a>
          <a href="javascript:" class="weui-dialog__btn weui-dialog__btn_primary" style="color: #da2819;" @click="signcoue()">同意并继续</a>
        </div>
      </div>
    </div>
    <div class="js_dialog" id="iosDialog2" :style="'display:' + signtemt">
      <div class="weui-mask"></div>
      <div class="weui-dialog">
        <div class="weui-dialog__bd" style="margin: 0 0 .24rem 0;"></div>
        <div class="weui-dialog__bd" style="text-align: left;">您需要同意《用户协议》和《隐私政策》才能继续使用欧堡利亚APP，若您不同意本《用户协议》和《隐私政策》，很遗憾我们将无法为您提供服务。</div>
        <div class="weui-dialog__ft">
          <a href="javascript:" class="weui-dialog__btn weui-dialog__btn_primary" @click="signknow()">知道了</a>
        </div>
      </div>
    </div>
    <TextTips></TextTips>
  </div>
</template>

<script>
import "./obraojs/rem"
export default {
  data () {
    return{
      signacnt: '',
      signpaor: '',
      signfail: 'none',
      sidnsucs: 'none',
      signtips: '',
      signment: 'none',
      signtemt: 'none',
      tenderms: ''
    }
  },
  created () {
    // 从缓存里获取判断声明与条款是否应该出现的标识
    this.tenderms = localStorage.getItem("santdems");
    if(this.tenderms == '0'){
      this.signment = 'none';
    }else{
      this.signment = 'block';
    }
  },
  mounted () {
    
  },
  methods: {
    // 点击拒绝触发
    signfuse(){
      this.signment = 'none';
      this.signtemt = 'block';
    },
    // 点击同意并继续触发
    signcoue(){
      localStorage.setItem("santdems", '0');
      this.signment = 'none';
    },
    // 点击知道了触发
    signknow(){
      this.signtemt = 'none';
      this.signment = 'block';
    },
    // 获取输入的账号
    signacer(){
      // console.log(this.signacnt);
    },
    // 获取输入的密码
    signpard(){
      // console.log(this.signpaor);
    },
    // 向后台校验账号和密码是否正确
    signcfrm(){
      if(this.signacnt == ''){
        this.signtips = '用户名不能为空';
        this.signfail = 'block';
        const _this = this;
        setTimeout(function(){
          _this.signfail = 'none';
        },1200)
      }else if(this.signpaor == ''){
        this.signtips = '密码不能为空';
        this.signfail = 'block';
        const _this = this;
        setTimeout(function(){
          _this.signfail = 'none';
        },1200)
      }else{
        this.$axios.post('app/oldAppLogin',this.$qs.stringify({
          username: this.signacnt,
          password: this.signpaor
        }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
        .then(res => {
          if(res.data.code == '200'){
            localStorage.setItem("phoneber", this.signacnt);
            localStorage.setItem("password", this.signpaor);
            localStorage.setItem("usertoken", res.data.data.token);
            this.signtips = res.data.msg;
            this.sidnsucs = 'block';
            const _this = this;
            setTimeout(function(){
              _this.sidnsucs = 'none';
              _this.$router.push({name: 'HomePage'});
            },1200)
          }else{
            this.signtips = '账号或密码输入错误!';
            this.signfail = 'block';
            const _this = this;
            setTimeout(function(){
              _this.signfail = 'none';
            },1200)
          }
        })
        .catch(() => {
          console.log('获取失败');
        });
      }
    }
  }
}
</script>

<style scoped>
  @import "obraocs/signin.css";
</style>